module.exports = __webpack_public_path__ + "img/first-installments.4a15190f.svg";